let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cyYCK")).then(() => parcelRequire('bHwwB'));